"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedItemTypeDto = exports.FeedItemStatusDto = exports.ScheduleDaysTypeDto = exports.TimeZoneTypeDto = exports.EventVisibility = exports.EventState = void 0;
var EventState;
(function (EventState) {
    EventState["DRAFT"] = "draft";
    EventState["ANNOUNCED"] = "announced";
    EventState["PUBLISHED"] = "published";
})(EventState = exports.EventState || (exports.EventState = {}));
var EventVisibility;
(function (EventVisibility) {
    EventVisibility["PUBLIC"] = "public";
    EventVisibility["PRIVATE"] = "private";
})(EventVisibility = exports.EventVisibility || (exports.EventVisibility = {}));
var TimeZoneTypeDto;
(function (TimeZoneTypeDto) {
    TimeZoneTypeDto["LOCAL"] = "local";
    TimeZoneTypeDto["GLOBAL"] = "global";
})(TimeZoneTypeDto = exports.TimeZoneTypeDto || (exports.TimeZoneTypeDto = {}));
var ScheduleDaysTypeDto;
(function (ScheduleDaysTypeDto) {
    ScheduleDaysTypeDto["SEPARATE"] = "separate";
    ScheduleDaysTypeDto["STACKED"] = "stacked";
})(ScheduleDaysTypeDto = exports.ScheduleDaysTypeDto || (exports.ScheduleDaysTypeDto = {}));
var FeedItemStatusDto;
(function (FeedItemStatusDto) {
    FeedItemStatusDto["DRAFT"] = "draft";
    FeedItemStatusDto["PUBLISHED"] = "published";
    FeedItemStatusDto["DELETED"] = "deleted";
})(FeedItemStatusDto = exports.FeedItemStatusDto || (exports.FeedItemStatusDto = {}));
var FeedItemTypeDto;
(function (FeedItemTypeDto) {
    FeedItemTypeDto["TXT"] = "txt";
    FeedItemTypeDto["MD"] = "md";
})(FeedItemTypeDto = exports.FeedItemTypeDto || (exports.FeedItemTypeDto = {}));
